import { createLogger } from "./logger";
const logger = createLogger("Cookie");
async function getCookie(cookiename) {
    logger.logInfo(`Reading cookie with name ${cookiename}`);
    if ("cookieStore" in window) {
        const cookie = await window.cookieStore.get(cookiename);
        return cookie?.value;
    }
    const name = `${cookiename}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    let i = 0;
    for (i; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return undefined;
}
function setDocumentCookie(cname, cvalue, exdays) {
    const expires = `expires=${exdays}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
}
async function setCookie(cname, cvalue, exdays) {
    logger.logInfo(`Setting cookie ${cname}=${cvalue}, expires: ${exdays}`);
    if ("cookieStore" in window) {
        try {
            await window.cookieStore.set({
                name: cname,
                value: cvalue,
                expires: exdays.getTime(),
            });
        }
        catch (e) {
            logger.logError(`Unable to set cookie with cookieStore: ${e}. Using document.cookie`);
            setDocumentCookie(cname, cvalue, exdays);
        }
    }
    else {
        setDocumentCookie(cname, cvalue, exdays);
    }
}
export { getCookie, setCookie };
//# sourceMappingURL=cookies.js.map